import { render, staticRenderFns } from "./FiltroFornecedores.vue?vue&type=template&id=ea1c3706&"
import script from "./FiltroFornecedores.vue?vue&type=script&lang=js&"
export * from "./FiltroFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports